import * as React from 'react';

import * as TimeUtils from '@acceligentllc/shared/utils/time';

import { bemElement } from 'af-utils/bem.util';

type Props = {
	eqMinutes: number;
	jobMinutes: number;
	label: string;
	className?: string;
};

const EquipmentTimeWarning: React.FC<Props> = ({ eqMinutes, jobMinutes, label, className }) => {
	const eq = TimeUtils.minutesToHoursAndMinutes(eqMinutes);
	const job = TimeUtils.minutesToHoursAndMinutes(jobMinutes);

	return (
		<div
			className={[
				bemElement('time-sheet-list__equipment-modal', 'equipment-time-warning'),
				className,
			].filter(Boolean).join(' ')}
		>
			<span className="icon-info" />
			{`Equipment time (${eq}) is less than Job time (${job}) for ${label}`}
		</div>
	);
};

export default React.memo(EquipmentTimeWarning);
